var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMisReportwhiteicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3541 16.4875C18.7489 22.6625 10.2749 24.4625 5.4176 19.65C0.656143 14.9313 2.1301 6.38542 8.3926 3.64584",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4196 13.0208C20.3863 13.0208 21.3696 13.0208 22.004 12.1406C22.028 12.1073 22.0665 12.049 22.0884 12.0146C22.6592 11.0906 22.3655 10.3813 21.7769 8.9625C21.244 7.67577 20.4628 6.50661 19.478 5.52181C18.4932 4.537 17.3241 3.75583 16.0373 3.22292C14.6186 2.63438 13.9092 2.34063 12.9853 2.91042C12.9509 2.9323 12.8915 2.97292 12.8592 2.99584C11.979 3.63125 11.979 4.61355 11.979 6.57917V8.77813C11.979 10.7781 11.979 11.7781 12.5998 12.4C13.2217 13.0208 14.2217 13.0208 16.2207 13.0208H18.4196Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisReportwhiteicon);
export default __webpack_public_path__ + "static/media/MIS Report white icon.4c5e2bd94f059281df4bc6b9c87d32de.svg";
export { ForwardRef as ReactComponent };